import { useEffect, useState } from 'react';
import { supabase } from '../../../../lib/supabase';
import { WHATSAPP_CONNECTED_STATUSES } from '../autoMovement.constants';

export type WhatsAppConnectionOption = {
    id: string;
    instance_name: string;
    phone_number: string | null;
    integration_id: string | null;
};

export function useWhatsAppConnections(organizationId?: string, enabled = true) {
    const [connections, setConnections] = useState<WhatsAppConnectionOption[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!organizationId || !enabled) return;

        let cancelled = false;

        const loadConnections = async () => {
            setLoading(true);
            try {
                const { data: instances, error } = await supabase
                    .from('whatsapp_instances')
                    .select('id, instance_name, phone_number, status, integration_id')
                    .eq('organization_id', organizationId);

                if (error) throw error;

                let connected = (instances || [])
                    .filter((instance) => WHATSAPP_CONNECTED_STATUSES.has(instance.status))
                    .map((instance) => ({
                        id: instance.id,
                        instance_name: instance.instance_name,
                        phone_number: instance.phone_number,
                        integration_id: instance.integration_id,
                    }));

                if (!connected.length) {
                    const { data: integrations, error: integError } = await supabase
                        .from('integrations')
                        .select('id, name, config, status')
                        .eq('organization_id', organizationId)
                        .eq('type', 'whatsapp')
                        .eq('status', 'connected');

                    if (integError) throw integError;

                    connected = (integrations || []).map((integration) => ({
                        id: integration.id,
                        instance_name: integration.config?.instance_name || integration.name,
                        phone_number: integration.config?.display_number || null,
                        integration_id: integration.id,
                    }));
                }

                if (!cancelled) setConnections(connected);
            } catch (error) {
                console.error('[AutoMovementForm] Erro ao carregar canais:', error);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        loadConnections();
        return () => { cancelled = true; };
    }, [organizationId, enabled]);

    return { connections, loading };
}
